import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const useDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [editingDriver, setEditingDriver] = useState(null);
  const [genericSavedMsg, setgenericSavedMsg] = useState("");

  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/drivers`)
      .then(res => res.json())
      .then(data => setDrivers(data));
  }, []);

  const addDriver = async (driverData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/drivers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(driverData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al guardar el conductor");
        return { error: result.error };
      }
      setDrivers(prev => [...prev, result]);
      setgenericSavedMsg("Conductor guardado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al guardar el conductor");
      return { error: "Error al guardar el conductor" };
    }
  };

  const editDriver = async (driverData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/drivers/${driverData.license}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(driverData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al editar el conductor");
        return { error: result.error };
      }
      setDrivers(prev =>
        prev.map(d => d.license === driverData.license ? result : d)
      );
      setgenericSavedMsg("Conductor editado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setEditingDriver(null);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al editar el conductor");
      return { error: "Error al editar el conductor" };
    }
  };

  const removeDriver = async (license) => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar este conductor?")) return;
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/drivers/${license}`, {
        method: 'DELETE'
      });
      if (!response.ok) throw new Error('Error al eliminar el conductor');
      setDrivers(prev => prev.filter(d => d.license !== license));
      setgenericSavedMsg("Conductor eliminado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
    } catch (err) {
      setgenericSavedMsg("Error al eliminar el conductor");
    }
  };

  return {
    drivers,
    addDriver,
    editDriver,
    removeDriver,
    editingDriver,
    setEditingDriver,
    genericSavedMsg
  };
};

export default useDrivers;